{
  "version": 1,
  "asset_id": "d4dd5210-3d8f-46f5-8f9f-b75cec3aad7c",
  "project_id": "ede4779f-2e7a-461a-91d6-654024119c69",
  "url": "/__l5e/assets-v1/d4dd5210-3d8f-46f5-8f9f-b75cec3aad7c/list-referencyjny-ewelina-sasin.pdf",
  "r2_key": "a/v1/ede4779f-2e7a-461a-91d6-654024119c69/d4dd5210-3d8f-46f5-8f9f-b75cec3aad7c/list-referencyjny-ewelina-sasin.pdf",
  "original_filename": "list-referencyjny-ewelina-sasin.pdf",
  "size": 442263,
  "content_type": "application/pdf",
  "created_at": "2026-10-02T13:11:51Z"
}
